import React from 'react';
import PropTypes from 'prop-types';
import View from './View/View';
import Search from './Search/Search';
import FiltersModal from './Filters/FiltersModal';
import Total from './Total/Total';
import closeIcon from './images/close-icon.svg';

const HeaderMobile = ({
    currentPath,
    keyword,
    filters,
    filtersOff,
    filterMapOff,
    options,
    maxSqFts,
    handleKeywordChange,
    handleFilterChange,
    handleClear,
    totalText,
}) => (
    <div>
        <div id="_searching" className="section grid-search-container">
            <div className="container">
                <div className="columns">
                    <div className="column">
                        <Search keyword={keyword} handleChange={handleKeywordChange} />
                    </div>
                </div>
                <div className="columns is-mobile">
                    <div className="column">
                        <View currentPath={currentPath} />
                    </div>
                    <div className="column">
                        <FiltersModal
                            filters={filters}
                            filtersOff={filtersOff}
                            options={options}
                            maxAvailSqFt={maxSqFts}
                            handleChange={handleFilterChange}
                            handleClear={handleClear} />
                    </div>
                </div>
            </div>
        </div>
        {(!filtersOff || !filterMapOff || keyword !== '') &&
            <div className="columns is-marginless is-mobile active-filters-mobile">
                <button onClick={handleClear} className="column is-one-third clear-button-wrapper">
                    <img className="button-icon" src={closeIcon} alt={closeIcon} />
                    <div className="button-text">CLEAR</div>
                </button>
                <div className="column">
                    <div className="active-filter-title">FILTERING FOR:</div>
                    <ul className="active-filter-text">
                        {keyword !== '' && <li>Property Name</li>}
                        {!filterMapOff && <li>Map Filter</li>}
                        {filters.region && <li>{filters.region.label}</li>}
                        {filters.subMarket && <li>{filters.subMarket.label}</li>}
                        {filters.projectType && <li>{filters.projectType.label}</li>}
                        {filters.totalSqFt && <li>{filters.totalSqFt.label}</li>}
                        {filters.availableSqFt && <li>Avail. SQ FT</li>}
                    </ul>
                </div>
            </div>
        }
        <Total totalText={totalText} />
    </div>
);

HeaderMobile.propTypes = {
    currentPath: PropTypes.string.isRequired,
    keyword: PropTypes.string,
    filters: PropTypes.shape({
        region: PropTypes.shape({
            label: PropTypes.string,
        }),
        subMarket: PropTypes.shape({
            label: PropTypes.string,
        }),
        projectType: PropTypes.shape({
            label: PropTypes.string,
        }),
        totalSqFt: PropTypes.shape({
            label: PropTypes.string,
        }),
        availableSqFt: PropTypes.object,
    }).isRequired,
    filtersOff: PropTypes.bool.isRequired,
    filterMapOff: PropTypes.bool.isRequired,
    options: PropTypes.object.isRequired,
    maxSqFts: PropTypes.number.isRequired,
    totalText: PropTypes.string,
    handleKeywordChange: PropTypes.func.isRequired,
    handleFilterChange: PropTypes.func.isRequired,
    handleClear: PropTypes.func.isRequired,
};

export default HeaderMobile;
